
// add Agent page with function to add agent
import Navigation from '../Navbar/Navbar';
import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Container, Row, Col } from 'react-bootstrap';
import './AddAgent.css';
import axios from 'axios';

const apiUrl = "/api";


function AddAgent() {
  const [agentName, setAgentName] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  

  if (!localStorage.getItem('token')) {
     // Redirect to login page if not logged in 
     window.location.href = '#/login';
     return null;
  }
  const handleAddAgent = () => {
    // Make an API call to add the agent to the database
    // (You need to implement the actual API call)
    const tenantId = parseInt(localStorage.getItem('selectedTenant')) || 1;
    console.log(`Adding agent: ${agentName}`);
    const token = localStorage.getItem('token');
    axios.post(apiUrl+'/createnewuser', { agentName, tenant_id: tenantId }, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      console.log(response.data);
      setTimeout(() => {
        setShowAlert(true);
        setAgentName('');
      }, 2000);

    })
    .catch((error) => {
      console.error('Error adding agent:', error);
    });
}
    
    // For this example, let's simulate a successful API call after 2 seconds
  return (
    <div>
        <Navigation />
        <Container className="mt-4">
            <Row className="mb-4">
                <Col>
                    <h1 className="text-center mb-4 add-agent-heading">
                        Add New Agent
                    </h1>
                </Col>
            </Row>
            <div className="add-agent-container">
                <div className="add-agent-box">
                    <Alert variant="success" show={showAlert} onClose={() => setShowAlert(false)} dismissible>
                        Agent added successfully!
                    </Alert>
                    <Form>
                        <Form.Group controlId="agentName" className="mb-3">
                            <Form.Label>Agent Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter agent name"
                                value={agentName}
                                onChange={(e) => setAgentName(e.target.value)}
                            />
                        </Form.Group>
                        <Button variant="primary" className="custom-button" onClick={handleAddAgent}>
                            Add Agent
                        </Button>
                    </Form>
                </div>
            </div>
        </Container>
    </div>
      );
}

export default AddAgent;
